var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '@environments/environment.style';
import { DATES_BOOKING_STEPS_STATE } from '@ibe.components/booking/booking.setup'; // TODO
import { BookedTrip, Flight } from '@ibe/models';
import { BookingStep } from '@ibe/models/ui';
import { TAPDataStorageService } from '@ibe/services/mocks.tap';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { Observable, of, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BookedTripEffect } from '../effects';
import * as fromStore from '../store';
import * as BookedTripActions from '../store/actions/booked-trip.actions';
import * as BookingStepActions from '../store/actions/booking-steps.actions';
import { PutFlightInformationAction, ResetAction } from "@ibe/store/actions/flight-information.indra.actions";
import { PutOutboundFlightInformationAction, ResetOutboundFlightInformationAction } from '@ibe/store/actions/outbound-flight-information.indra.actions';
import { PutInboundFlightInformationAction, ResetInboundFlightInformationAction } from '@ibe/store/actions/inbound-flight-information.indra.actions';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
import * as i3 from "./mocks.tap/data-storage.tap.service";
import * as i4 from "@ngrx/store";
import * as i5 from "../effects/booked-trip.effects";
var BookingService = /** @class */ (function () {
    function BookingService(_http, router, storage, store, bookedTripEffects, route) {
        var _this = this;
        this._http = _http;
        this.router = router;
        this.storage = storage;
        this.store = store;
        this.bookedTripEffects = bookedTripEffects;
        this.route = route;
        // Flight booking steps
        this.booking_steps$ = this.store.select(fromStore.getSelectedBookingSteps);
        this.current_step$ = this.store.select(fromStore.getSelectedBookingCurrentStep);
        this.booking_type$ = this.store.select(fromStore.getSelectedBookingType);
        // Active Booking Trip
        this.booking_trip$ = this.store.select(fromStore.getSelectedBookedTrip);
        /*only to get flight form mock*/
        this.flight$ = this.store.select(fromStore.getSelectedFlightFromFlightResults);
        this.paymentStatus = new Subject();
        this._current_step = 0;
        this.booking_steps$.subscribe(function (value) { return _this._steps = value; });
        this.current_step$.subscribe(function (value) { return _this._current_step = value; });
        this.booking_trip$.subscribe(function (value) { return _this._booking_trip = value; });
        this.booking_type$.subscribe(function (value) { return _this._booking_type = value; });
        moment.locale(environment.locale);
        // this.storage.initializeActiveBookingIfEmpty();
        this.flight$.subscribe(function (flight) { _this.flightFromMock = flight; });
    }
    Object.defineProperty(BookingService.prototype, "booking_type", {
        get: function () {
            return this._booking_type;
        },
        enumerable: true,
        configurable: true
    });
    /** Initialize mocked booking steps */
    BookingService.prototype.initializeBookingSteps = function () {
        this._steps = DATES_BOOKING_STEPS_STATE;
        this.store.dispatch(new BookingStepActions.PutStepsAction(this._steps));
        this._current_step = 0;
        this.store.dispatch(new BookingStepActions.PutCurrentStepAction(this._current_step));
    };
    /** Reset Booking to initial state */
    BookingService.prototype.resetBooking = function () {
        this._steps = null;
        this.store.dispatch(new BookingStepActions.ResetAction);
        this._current_step = 0;
        this.store.dispatch(new BookingStepActions.PutCurrentStepAction(this._current_step));
    };
    Object.defineProperty(BookingService.prototype, "passengerTotal", {
        /** Get total of booking passengers */
        get: function () {
            if (this._booking_trip && this._booking_trip.passengers_info !== null) {
                return this._booking_trip.passengers_info.length;
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BookingService.prototype, "passengers", {
        /** Get booking passengers */
        get: function () {
            return this._booking_trip.passengers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BookingService.prototype, "passengers_info", {
        /** Get booking passengers info */
        get: function () {
            return this._booking_trip.passengers_info;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BookingService.prototype, "pnr", {
        /** Get booking passengers info */
        get: function () {
            return this._booking_trip.pnr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BookingService.prototype, "contact_details", {
        /** Get booking contact details */
        get: function () {
            return this._booking_trip.contact_details;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Change active reservation status
     * Add booking to list of user bookings
     * Reset active booking
     */
    BookingService.prototype.completeActiveBooking = function (newStatus) {
        if (newStatus === void 0) { newStatus = 'active'; }
        this.setStatus(newStatus);
        var newBookedTrip = Object.assign(new BookedTrip(null, null, null), this._booking_trip, { added_to_account: true });
        this.bookedTripEffects.updateBookedTrip(newBookedTrip.pnr, newBookedTrip);
        this.store.dispatch(new BookingStepActions.ResetAction);
    };
    /** Change booking status */
    BookingService.prototype.setStatus = function (status) {
        var newBookedTrip = Object.assign(new BookedTrip(null, null, null), this._booking_trip, { status: status });
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(newBookedTrip));
    };
    /**
     *set the value for the time to think booked trip
     *
     * @param {boolean} value
     * @memberof BookingService
     */
    BookingService.prototype.setTimeToThink = function (value) {
        var newBookedTrip = Object.assign(new BookedTrip(null, null, null), this._booking_trip, { is_time_to_think: value });
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(newBookedTrip));
    };
    BookingService.prototype.setCarbonOffset = function (value) {
        var newBookedTrip = Object.assign(new BookedTrip(null, null, null), this._booking_trip, { carbonOffset: value });
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(newBookedTrip));
    };
    BookingService.prototype.setPreferredBoarding = function (value) {
        var newBookedTrip = Object.assign(new BookedTrip(null, null, null), this._booking_trip, { preferredBoarding: value });
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(newBookedTrip));
    };
    BookingService.prototype.setExtraChanged = function (key, value) {
        var extra = {};
        extra[key] = value;
        var newBookedTrip = Object.assign(new BookedTrip(null, null, null), this._booking_trip, extra);
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(newBookedTrip));
    };
    BookingService.prototype.setPaymentInfo = function (value) {
        var newBookedTrip = Object.assign(new BookedTrip(null, null, null), this._booking_trip, { payment: value });
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(newBookedTrip));
    };
    BookingService.prototype.removeExtra = function (type) {
        this.store.dispatch(new BookedTripActions.RemoveBookedTripExtraAction(type));
    };
    /**
     * Get booking total price
     * @returns booking total price
     */
    BookingService.prototype.getPrice = function () {
        var totalPrice = 0;
        for (var _i = 0, _a = this._booking_trip.flights; _i < _a.length; _i++) {
            var flight = _a[_i];
            totalPrice += flight.options.price;
        }
        if (this._booking_trip.carbon_offset)
            totalPrice += 12;
        if (this._booking_trip.danish_guarantee_fund)
            totalPrice += 60;
        return totalPrice + '';
    };
    Object.defineProperty(BookingService.prototype, "bookingTotal", {
        /** Returns the total price of all flights for all passengers */
        get: function () {
            return this._booking_trip.flights
                .filter(function (f) { return f !== undefined; })
                .reduce(function (sum, f) { return (sum += f.options.price); }, 0);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * When the last step is reached and the route must be changed,
     * call this function
     */
    BookingService.prototype.goToNextRoute = function () {
        var current_route = this.router.url;
        var split = current_route.split('?');
        var route_split = split && split[0] ? split[0] : current_route;
        switch (route_split) {
            case '/booking/dates':
                this.router.navigateByUrl('/booking/flights');
                return;
            case '/booking/dates/deeplink':
                this.router.navigateByUrl('/booking/flights');
                return;
            case '/booking/flights':
                this.router.navigate(['/booking/review-your-trip']);
                return;
            case '/booking/flights/deeplink':
                this.router.navigate(['/booking/review-your-trip']);
                return;
            case '/booking/flights-multicity':
                this.router.navigate(['/booking/review-your-trip']);
                return;
            case '/booking/flights-multicity/deeplink':
                this.router.navigate(['/booking/review-your-trip']);
                return;
            case '/booking/main/deeplink':
                this.router.navigate(['/booking/review-your-trip']);
                return;
            default:
                console.error(current_route);
                return;
        }
    };
    /**
     * Checks if all dates have been selected for the ongoing booking
     * @returns {boolean}
     */
    BookingService.prototype.allDatesSelected = function () {
        for (var i = 0; i < this._steps.length; i++) {
            if (!this._steps[i].date_selected) {
                return false;
            }
        }
        return true;
    };
    /**
     * Checks if all flights have been selected for the ongoing booking
     * @returns {boolean}
     */
    BookingService.prototype.allFlightsSelected = function () {
        for (var i = 0; i < this._steps.length; i++) {
            if (!this._steps[i].flight_selected) {
                return false;
            }
        }
        return true;
    };
    BookingService.prototype.updateFooterData = function (stage, payload) {
        this.store.dispatch(new PutFlightInformationAction(stage, payload));
        if (payload && payload.flight && payload.flight.bound == "outbound") {
            this.store.dispatch(new PutOutboundFlightInformationAction(stage, payload));
        }
        else if (payload && payload.flight && payload.flight.bound == "inbound") {
            this.store.dispatch(new PutInboundFlightInformationAction(stage, payload));
        }
    };
    BookingService.prototype.clearOutboundFooterData = function () {
        this.store.dispatch(new ResetOutboundFlightInformationAction());
    };
    BookingService.prototype.clearInboundFooterData = function () {
        this.store.dispatch(new ResetInboundFlightInformationAction());
    };
    BookingService.prototype.clearFooterData = function () {
        this.store.dispatch(new ResetAction());
    };
    /**
     * Clear selected dates
     */
    BookingService.prototype.TAP_clearDates = function () {
        var auxArray = [];
        this._steps.forEach(function (step) {
            auxArray.push(Object.assign(new BookingStep(null, null), step, {
                cost: null,
                date: null,
                date_selected: false
            }));
        });
        this.store.dispatch(new BookingStepActions.PutStepsAction(auxArray));
        this.store.dispatch(new BookingStepActions.PutCurrentStepAction(0));
    };
    /**
     * Fetch results from url
     * @param params Booking-step-like object. Used in prototype to generate results,
     * should be sent as params in the request.
     */
    BookingService.prototype.getFlights = function (params, flightFilter) {
        var _this = this;
        if (flightFilter === void 0) { flightFilter = { directFlights: null, cabinOptions: null, schedule: null, airline: null, airlines: null, step: 0, baggageIncluded: null, onlyRefundable: null, bookAwardFlights: null, starAlliance: null }; }
        var filterDirectFlights = function (cur) {
            if (flightFilter.directFlights != null && flightFilter.directFlights) {
                if (cur.direct == flightFilter.directFlights) {
                    return true;
                }
                else {
                    return false;
                }
            }
            return true;
        };
        var filterCabinOptions = function (cur) {
            var result = true;
            if (flightFilter.cabinOptions && flightFilter.cabinOptions != 'all') {
                var total = Object.keys(cur).includes(flightFilter.cabinOptions);
                if (!total)
                    result = false;
            }
            return result;
        };
        var makeStarEnd = function (time) {
            var dtStart = moment().utc();
            var dtEnd = moment().utc();
            if (time == 'morning') {
                dtStart = dtStart.set({ 'hour': 4, 'minute': 0, 'second': 1 });
                dtEnd = dtEnd.set({ 'hour': 12, 'minute': 0, 'second': 0 });
            }
            else if (time == 'afternoon') {
                dtStart = dtStart.set({ 'hour': 12, 'minute': 0, 'second': 1 });
                dtEnd = dtEnd.set({ 'hour': 19, 'minute': 0, 'second': 0 });
            }
            else if (time == 'evening') {
                dtStart = dtStart.set({ 'hour': 19, 'minute': 0, 'second': 1 });
                dtEnd = dtEnd.set({ 'hour': 4, 'minute': 0, 'second': 0 });
            }
            else {
                dtStart = dtStart.set({ 'hour': 0, 'minute': 0, 'second': 0 });
                dtEnd = dtEnd.set({ 'hour': 23, 'minute': 59, 'second': 59 });
            }
            return [dtStart, dtEnd];
        };
        var filterSchedule = function (cur) {
            var result = true;
            if (flightFilter.schedule && flightFilter.schedule.length) {
                var _a = makeStarEnd(flightFilter.schedule[flightFilter.step].departure), departureDateDtStart = _a[0], departureDateDtEnd = _a[1];
                var _b = makeStarEnd(flightFilter.schedule[flightFilter.step].arrival), arrivalDateDtStart = _b[0], arrivalDateDtEnd = _b[1];
                var departureStart = moment(cur.departure.time).utc().set({ 'hour': parseFloat(departureDateDtStart.format('H')), 'minute': parseFloat(departureDateDtStart.format('m')), 'second': parseFloat(departureDateDtStart.format('s')) });
                var departureEnd = moment(cur.departure.time).utc().set({ 'hour': parseFloat(departureDateDtEnd.format('H')), 'minute': parseFloat(departureDateDtEnd.format('m')), 'second': parseFloat(departureDateDtEnd.format('s')) });
                var arrivalStart = moment(cur.arrival.time).utc().set({ 'hour': parseFloat(arrivalDateDtStart.format('H')), 'minute': parseFloat(arrivalDateDtStart.format('m')), 'second': parseFloat(arrivalDateDtStart.format('s')) });
                var arrivalEnd = moment(cur.arrival.time).utc().set({ 'hour': parseFloat(arrivalDateDtEnd.format('H')), 'minute': parseFloat(arrivalDateDtEnd.format('m')), 'second': parseFloat(arrivalDateDtEnd.format('s')) });
                var departure = moment(cur.departure.time).isBetween(departureStart, departureEnd);
                var arrival = moment(cur.arrival.time).isBetween(arrivalStart, arrivalEnd);
                if (departure && arrival) {
                    result = true;
                }
                else {
                    result = false;
                }
            }
            return result;
        };
        var filterAirline = function (cur) {
            var result = true;
            if (flightFilter.airline || flightFilter.bookAwardFlights) {
                // const total = flightFilter.airline.find(res => cur.airline.map(c => c.short).includes(res));
                // if (!total) result = false;
                if (flightFilter.starAlliance)
                    result = cur.airline.map(function (c) { return c.starAlliance === true; });
                else
                    result = cur.airline.map(function (c) { return c.short; }).includes('TAP');
            }
            return result;
        };
        var filterAirlines = function (cur) {
            if (!flightFilter.airline && flightFilter.airlines && flightFilter.airlines.length) {
                var airlines = cur.airline.map(function (c) { return c.short; });
                for (var i in airlines) {
                    if (flightFilter.airlines.indexOf(airlines[i]) > -1) {
                        return true;
                    }
                }
                return false;
            }
            return true;
        };
        var url = flightFilter.step == 0 ? './assets/data/flights-departure.json' : './assets/data/flights-arrival.json';
        var data = this._http.get(url).pipe(map(function (res) { return res['data']['results'].map(_this.castDates); }), map(function (res) { return res.filter(filterDirectFlights); }), map(function (res) { return res.filter(filterSchedule); }), map(function (res) { return res.filter(filterAirline); }), map(function (res) { return res.filter(filterAirlines); }), 
        // remove next map in real implementation
        map(function (res) { return res.map(_this.transformResults.bind(_this, params)); }), catchError(this.handleError(url, [])));
        return data;
    };
    BookingService.prototype.getFlightsMulticity = function (bookingSteps, filter) {
        var _this = this;
        var flightFilter = __assign({}, filter);
        flightFilter.airline = true;
        var brandsList = [];
        if (!filter.bookAwardFlights)
            brandsList = [
                { name: 'discount', price: 89.82, bookAwardValue: '9500M + 35' + environment.currency.symbol, state: 'available' },
                { name: 'basic', price: 119.82, bookAwardValue: '11.900M + 25' + environment.currency.symbol, state: 'available' },
                { name: 'classic', price: 129.82, bookAwardValue: '12.900M + 25' + environment.currency.symbol, state: 'available', recommended: true },
                { name: 'plus', price: 229.82, bookAwardValue: '22.900M + 45' + environment.currency.symbol, state: 'available' },
                { name: 'executive', price: 279.82, bookAwardValue: '35.000M + 50' + environment.currency.symbol, state: 'available' },
                { name: 'top-executive', price: 329.82, bookAwardValue: '42.000M + 80' + environment.currency.symbol, state: 'available' }
            ];
        else {
            if (filter.starAlliance)
                brandsList = [{ name: 'star_alliance-economy', price: 89.82, bookAwardValue: '9500M + 35' + environment.currency.symbol, state: 'available' },
                    { name: 'star_alliance-business', price: 129.82, bookAwardValue: '12.900M + 25' + environment.currency.symbol, state: 'available', recommended: true },
                    { name: 'star_alliance-first', price: 329.82, bookAwardValue: '42.000M + 80' + environment.currency.symbol, state: 'available' }];
            else
                brandsList = [{ name: 'miles&go-economy', price: 89.82, bookAwardValue: '9500M + 35' + environment.currency.symbol, state: 'available' },
                    { name: 'miles&go-extra', price: 129.82, bookAwardValue: '12.900M + 25' + environment.currency.symbol, state: 'available', recommended: true },
                    { name: 'miles&go-executive', price: 329.82, bookAwardValue: '42.000M + 80' + environment.currency.symbol, state: 'available' }];
        }
        /**
         * Dev ONLY
         */
        return new Promise(function (resolve, reject) {
            var result = false;
            var countBookingSteps = 0;
            var totalPacks = Math.floor(Math.random() * 9) + 2;
            var packs = [];
            for (var i = 0; i < totalPacks; i++)
                packs.push([]);
            for (var idx in bookingSteps) {
                var bookingStep = bookingSteps[idx];
                _this.getFlights(bookingStep, __assign({}, flightFilter, { step: parseFloat(idx) })).subscribe(function (cur) {
                    for (var i = 0; i < totalPacks; i++) {
                        if (cur.length) {
                            var flight = cur[Math.floor(Math.random() * cur.length)];
                            flight.options = {
                                price: parseFloat(flight && flight.economy ? flight.economy.lowest_price : 20) * Math.floor(Math.random() * 9),
                                brand: brandsList[Math.floor(Math.random() * brandsList.length)].name
                            };
                            packs[i].push(flight);
                        }
                        else {
                            packs[i].push(null);
                        }
                    }
                });
                ++countBookingSteps;
                if (bookingSteps.length == countBookingSteps)
                    result = true;
            }
            if (result) {
                setTimeout(function () { return resolve(packs.filter(function (cur) { return cur.filter(function (c) { return c == null; }).length == 0; })); }, 500);
            }
        });
    };
    BookingService.prototype.getFlightsStopover = function (bookingSteps, filter) {
        return __awaiter(this, void 0, void 0, function () {
            var flightFilter, totalPacks, packs, brandsList, makeInfoFlight, promiseAll, i;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        flightFilter = __assign({}, filter);
                        flightFilter.airline = true;
                        totalPacks = Math.floor(Math.random() * 9) + 2;
                        packs = [];
                        brandsList = [];
                        if (!filter.bookAwardFlights)
                            brandsList = [
                                { name: 'discount', price: 89.82, bookAwardValue: '9500M + 35' + environment.currency.symbol, state: 'available' },
                                { name: 'basic', price: 119.82, bookAwardValue: '11.900M + 25' + environment.currency.symbol, state: 'available' },
                                { name: 'classic', price: 129.82, bookAwardValue: '12.900M + 25' + environment.currency.symbol, state: 'available', recommended: true },
                                { name: 'plus', price: 229.82, bookAwardValue: '22.900M + 45' + environment.currency.symbol, state: 'available' },
                                { name: 'executive', price: 279.82, bookAwardValue: '35.000M + 50' + environment.currency.symbol, state: 'available' },
                                { name: 'top-executive', price: 329.82, bookAwardValue: '42.000M + 80' + environment.currency.symbol, state: 'available' }
                            ];
                        else {
                            if (filter.starAlliance)
                                brandsList = [{ name: 'star_alliance-economy', price: 89.82, bookAwardValue: '9500M + 35' + environment.currency.symbol, state: 'available' },
                                    { name: 'star_alliance-business', price: 129.82, bookAwardValue: '12.900M + 25' + environment.currency.symbol, state: 'available', recommended: true },
                                    { name: 'star_alliance-first', price: 329.82, bookAwardValue: '42.000M + 80' + environment.currency.symbol, state: 'available' }];
                            else
                                brandsList = [{ name: 'miles&go-economy', price: 89.82, bookAwardValue: '9500M + 35' + environment.currency.symbol, state: 'available' },
                                    { name: 'miles&go-extra', price: 129.82, bookAwardValue: '12.900M + 25' + environment.currency.symbol, state: 'available', recommended: true },
                                    { name: 'miles&go-executive', price: 329.82, bookAwardValue: '42.000M + 80' + environment.currency.symbol, state: 'available' }];
                        }
                        makeInfoFlight = function (bookingStep, idx) {
                            if (idx === void 0) { idx = 0; }
                            return __awaiter(_this, void 0, void 0, function () {
                                var cur, flight;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.getFlights(bookingStep, __assign({}, flightFilter, { step: idx })).toPromise()];
                                        case 1:
                                            cur = _a.sent();
                                            if (cur.length) {
                                                flight = cur[Math.floor(Math.random() * cur.length)];
                                                flight.options = {
                                                    price: parseFloat(flight && flight.economy ? flight.economy.lowest_price : 20) * Math.floor(Math.random() * 9),
                                                    brand: brandsList[Math.floor(Math.random() * brandsList.length)].name
                                                };
                                                flight.type = 'flight';
                                                if (bookingStep.stopover) {
                                                    flight.stopover = bookingStep.stopover;
                                                    flight.arrival = {
                                                        airport: bookingStep.stopover.airport,
                                                        time: flight.arrival.time
                                                    };
                                                }
                                                return [2 /*return*/, flight];
                                            }
                                            return [2 /*return*/, null];
                                    }
                                });
                            });
                        };
                        promiseAll = function () {
                            return bookingSteps.reduce(function (acc, bookingStep, idx) {
                                var flight = makeInfoFlight(bookingStep, idx);
                                if (flight)
                                    acc.push(flight);
                                if (bookingStep.stopover) {
                                    acc.push(Object.assign({ type: 'stopover', options: { price: 200.82 } }, bookingStep.stopover));
                                }
                                return acc;
                            }, []);
                        };
                        for (i = 0; i < totalPacks; i++)
                            packs.push(Promise.all(promiseAll()));
                        return [4 /*yield*/, Promise.all(packs)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Fetch result from url
     */
    BookingService.prototype.getFlight = function (params, id, options) {
        var _this = this;
        if (options === void 0) { options = { step: 0 }; }
        var url = options.step == 0 ? './assets/data/flights-departure.json' : './assets/data/flights-arrival.json';
        return this._http.get(url).pipe(map(function (res) { return res['data']['results'].map(_this.castDates); }), map(function (res) { return res.find(function (cur) { return cur.id == id; }); }), catchError(this.handleError(url, [])));
    };
    /**
     * Returns corresponding flight of an ID if it exists
     * @param {string} id of flight to return
     */
    BookingService.prototype.getBookedFlight = function (id) {
        var result = this._booking_trip.getFlight(id);
        if (!result) {
            if (this.flightFromMock)
                return this.flightFromMock;
            return false;
        }
        else {
            return result;
        }
    };
    /**
     * Returns true if the active booking has the flight identified by the
     * given id
     * @param id - the flight identifier
     */
    BookingService.prototype.hasBookedFlight = function (id) {
        return !!this._booking_trip.getFlight(id);
    };
    /**
     * Returns passengers from a flight corresponding to an ID, if it exists
     * @param {string} id - the id of flight
     */
    BookingService.prototype.getFlightPassengers = function (id) {
        var flight = this.getBookedFlight(id);
        if (flight) {
            return flight.passengerInfo;
        }
        else {
            return [];
        }
    };
    /**
     * Finds the flight that follows the one identified by the given id on this booking
     * @param id {string} - the id of the current flight
     */
    BookingService.prototype.getNextBookedFlight = function (id) {
        var index = this._booking_trip.flights.findIndex(function (f) { return f.id === id; });
        if (index === -1) {
            index = 0;
        }
        else {
            index = (index + 1) % this._booking_trip.flights.length;
        }
        return this._booking_trip.flights[index];
    };
    /**
     * Returns an array of the remaining flights in the current booking
     * @param id - the flight id
     */
    BookingService.prototype.getOtherFlights = function (id) {
        return this._booking_trip.flights.filter(function (f) { return f.id !== id; });
    };
    /**
     * Cast date strings gotten from mock into Date objs
     * @param e result item from mock json
     */
    BookingService.prototype.castDates = function (e) {
        e.arrival.time = new Date(e.arrival.time);
        e.departure.time = new Date(e.departure.time);
        return e;
    };
    /**
     * DEV ONLY
     * Changes dates and city names on result to correspond to the search params
     * @param params search params
     * @param e result to transform
     */
    BookingService.prototype.transformResults = function (params, e) {
        e.id = e.id;
        e.arrival.airport = params && params._arrival ? params._arrival : null;
        e.departure.airport = params && params._departure ? params._departure : null;
        if (params && params.date) {
            var targetDate = new Date(params.date);
            e.departure.time = new Date(e.departure.time);
            e.departure.time.setDate(targetDate.getDate());
            e.departure.time.setMonth(targetDate.getMonth());
            e.departure.time.setFullYear(targetDate.getFullYear());
            e.arrival.time = new Date(e.arrival.time);
            var nextDay = Math.random() < 0.1;
            // DEV Only - Used only to force +1 on arrival date
            // TODO - Remove
            if (nextDay) {
                e.arrival.time.setDate(targetDate.getDate() + 1);
            }
            else {
                e.arrival.time.setDate(targetDate.getDate());
            }
            e.arrival.time.setMonth(targetDate.getMonth());
            e.arrival.time.setFullYear(targetDate.getFullYear());
        }
        return e;
    };
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    BookingService.prototype.handleError = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    };
    /**
     * Adds booking exemple to active bookings from Retrieve PNR Locator form
     * Changes PNR of booking from exemple, with the one on the input
     */
    BookingService.prototype.addBookingFromRetrievePNRLocator = function (tripPNR) {
        this.storage.initializerRetrievePNRLocator(tripPNR);
    };
    /**
     * Adds booking exemple to active bookings from Retrieve PNR Locator form
     * Changes PNR of booking from exemple, with the one on the input
     */
    BookingService.prototype.addBookingFromRetrievePNRLocatorGroups = function (tripPNR) {
        this.storage.initializerRetrievePNRLocatorGroups(tripPNR);
    };
    /** STEPS */
    /**
     * Create booking steps based on formValue
     * @param bookedTrip
     */
    BookingService.prototype.createChangeBookingSteps = function (selectedFlights) {
        this._steps = this.TAP_createStepsArray(selectedFlights);
        this.store.dispatch(new BookingStepActions.PutStepsAction(this._steps));
    };
    BookingService.prototype.TAP_createStepsArray = function (selectedFlightsArray) {
        var STEPS_ARRAY = [];
        selectedFlightsArray.forEach(function (element) {
            STEPS_ARRAY.push(new BookingStep(element.departure.airport, element.arrival.airport));
        });
        /*for (let index = 0; selectedFlightsArray.length > index; index++) {
            STEPS_ARRAY.push(
                new BookingStep(
                    selectedFlightsArray[index].flight.departure.airport,
                    selectedFlightsArray[index].flight.arrival.airport
                )
            );
        }*/
        return STEPS_ARRAY;
    };
    /**
     * Sets the current step to @value
     * @param value value to set the current step to
     */
    BookingService.prototype.setCurrentStep = function (value) {
        this._current_step = value;
        this.store.dispatch(new BookingStepActions.PutCurrentStepAction(this._current_step));
    };
    /**
     * Gets the current step number
     */
    BookingService.prototype.getCurrentStepPosition = function () {
        return this._current_step;
    };
    /**
     * Gets the step from position
     */
    BookingService.prototype.getStep = function (stepPosition) {
        if (stepPosition === void 0) { stepPosition = this._current_step; }
        return this._steps[stepPosition];
    };
    /**
     * Sets the flight and flight date for the indicated index
     * @param flight Flight object to add to this._flights
     * @param index Flight index. If null, will use current_step
     * @param time Time of the flight. Should be sent explicitly
     * in case flight object changes.
     */
    BookingService.prototype.setFlight = function (flight, time, index) {
        if (index === void 0) { index = this._current_step; }
        var neue_flight = Object.assign(new Flight(flight.departure, flight.arrival, flight.number), flight);
        this._booking_trip.passengers_info.forEach(function (passenger) {
            var info = neue_flight.assignPassenger(passenger);
            info.seat = null;
        });
        if (flight.stopover)
            neue_flight.setStopover(flight.stopover);
        var flights = this._booking_trip.flights.map(function (cur) { return Object.assign(new Flight(null, null, null), cur); });
        flights[index] = neue_flight;
        var newBookedTrip = Object.assign(new BookedTrip(null, null, null), this._booking_trip, { flights: flights });
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(newBookedTrip));
        this.updateStepFlight(time, index);
        this.goToNextStep();
    };
    /** Called when a step is complete */
    BookingService.prototype.updateStepFlight = function (time, index) {
        var steps = this._steps.map(function (cur) { return Object.assign(new BookingStep(null, null), cur); }).slice();
        steps[index].flight_selected = true;
        steps[index].date = time;
        this.store.dispatch(new BookingStepActions.PutStepsAction(steps));
    };
    /** Called when a step is complete */
    BookingService.prototype.goToNextStep = function () {
        if (this._current_step === null) {
            this._current_step = 0;
            this.store.dispatch(new BookingStepActions.PutCurrentStepAction(this._current_step));
        }
        if (!this.isLastStep(this._current_step)) {
            this._current_step++;
            this.store.dispatch(new BookingStepActions.PutCurrentStepAction(this._current_step));
        }
    };
    /**
     * Sets bookingSteps[@index] to @value
     * @param value
     * @param index
     */
    BookingService.prototype.setStepDate = function (value, index) {
        var newObject = Object.assign(new BookingStep(null, null), this._steps[index], { date: value, date_selected: value !== null });
        var auxArray = this._steps.slice();
        auxArray[index] = newObject;
        this._steps = Object.assign([], this._steps, auxArray);
        this.store.dispatch(new BookingStepActions.PutStepsAction(this._steps));
        this.goToNextStep();
    };
    /**
     * Returns whether or not the given index is the last step of the booking process
     * @param index index of the step to check
     * @returns whether index is last step
     */
    BookingService.prototype.isLastStep = function (index) {
        if (!index)
            index = this._current_step;
        return index === this._steps.length - 1;
    };
    BookingService.prototype.getStopovers = function (searchRoutes, routeType) {
        var URL = './assets/data/stopover.json';
        var filePromise = this._http.get(URL).toPromise();
        var countrys = searchRoutes.filter(function (cur) { return cur.arrival && cur.departure; }).map(function (cur) { return ({ departure: cur.departure.code, arrival: cur.arrival.code }); });
        return new Promise(function (resolve, reject) {
            filePromise.then(function (data) {
                var stopovers = data
                    .filter(function (cur) {
                    return (countrys.map(function (c) { return c.departure; }).includes(cur.avaiable.departure.code) && countrys.map(function (c) { return c.arrival; }).includes(cur.avaiable.arrival.code)) ||
                        (cur.avaiable.departure == false && countrys.map(function (c) { return c.arrival; }).includes(cur.avaiable.arrival.code)) ||
                        (countrys.map(function (c) { return c.departure; }).includes(cur.avaiable.departure.code) && cur.avaiable.arrival == false);
                });
                if (routeType)
                    stopovers = stopovers.filter(function (cur) { return cur.route_type.includes(routeType); });
                /**
                 * Make labels inboubd/outbound
                 */
                stopovers = stopovers.map(function (cur, idx) {
                    var infoSearchRoute;
                    if (routeType == 'multicity') {
                        // infoSearchRoute = searchRoutes[idx];
                        infoSearchRoute = searchRoutes.find(function (v) { return v.arrival && v.arrival.code == cur.avaiable.arrival.code && v.departure && v.departure.code == cur.avaiable.departure.code; });
                    }
                    else {
                        infoSearchRoute = searchRoutes.find(function (v) { return v.arrival && v.arrival.code == cur.avaiable.arrival.code && v.departure && v.departure.code == cur.avaiable.departure.code; });
                        if (!infoSearchRoute)
                            infoSearchRoute = cur.avaiable;
                    }
                    cur.when = cur.when.map(function (c) {
                        if (c.value == 'inbound' && infoSearchRoute && infoSearchRoute.departure && infoSearchRoute.arrival) {
                            c.label = infoSearchRoute.departure.location.city + " - " + infoSearchRoute.arrival.location.city;
                            cur.id = infoSearchRoute.departure.code + "-" + infoSearchRoute.arrival.code;
                        }
                        if (c.value == 'outbound' && infoSearchRoute && infoSearchRoute.departure && infoSearchRoute.arrival) {
                            c.label = infoSearchRoute.arrival.location.city + " - " + infoSearchRoute.departure.location.city;
                            cur.id = infoSearchRoute.arrival.code + "-" + infoSearchRoute.departure.code;
                        }
                        return c;
                    });
                    return cur;
                });
                resolve(stopovers);
            });
        });
    };
    BookingService.ngInjectableDef = i0.defineInjectable({ factory: function BookingService_Factory() { return new BookingService(i0.inject(i1.HttpClient), i0.inject(i2.Router), i0.inject(i3.TAPDataStorageService), i0.inject(i4.Store), i0.inject(i5.BookedTripEffect), i0.inject(i2.ActivatedRoute)); }, token: BookingService, providedIn: "root" });
    return BookingService;
}());
export { BookingService };
